import * as React from 'react'
import { ProcessedMessage } from './useProcessMessage'
import useUser from '../useUser'
import { ModuleType } from '../../context/GlobalContext'
import useModules from '../module/useModules'
import useRoles, { rolesWriteAllTimes } from '../useRoles'
import TimeSuggestionToastContent from '../../components/Toast/TimeSuggestionToastContent'
import useQueueStateHandler, { QueueStatus } from '../useQueueStateHandler'
import { AxiosResponse } from 'axios'

/**
 * Messages originating from the Inboxer in order to invoke a TimeSuggestionDialog.
 */
export type TimeTrackingNotification = ProcessedMessage<{
    fileNumber: string
    timeSuggestionId: string
    date: string
    duration: string
    sender: string
    recipients: string
    emailInbound: boolean
    subject: string
}>

/**
 * Process a time-tracking event message. This invokes the TimeSuggestionDialog with custom initialValues.
 */
export default function useProcessTimeTrackingNotification() {
    const handler = useQueueStateHandler(props => <TimeSuggestionToastContent {...props} />)

    const modules = useModules()
    const roles = useRoles()
    const { currentUser } = useUser()

    return (message: TimeTrackingNotification) => {
        if (!modules.has(ModuleType.TimeTracking) || !roles.any(rolesWriteAllTimes) || currentUser?.useTimePopup === false) {
            // Only push a time tracking popup to time tracking users that want a popup.
            return
        }

        if (message.data?.timeSuggestionId === undefined) {
            return
        }

        handler.dispatch(message.data.timeSuggestionId, {
            baseURL: undefined,
            url: `/time-suggestion/${message.data.timeSuggestionId}`,
            method: 'GET',
            mapDispatchResponse: (response: AxiosResponse<void>) => response.data,
            callbacks: {
                [QueueStatus.Queued]: data => {
                    handler.transition(message.data.timeSuggestionId, QueueStatus.Finished, { ...data.status, current: QueueStatus.Finished })
                },
            },
        })
    }
}
